/* WJW mobile store updates. Announcement reads are local to this browser;
   NO order-status, restock, marketing push service, or shopper tracking. */
(function () {
  'use strict';
  function init() {
    var trigger = document.querySelector('.mobile-notification-trigger');
    var drawer = document.getElementById('wjw-mobile-notices');
    if (!trigger || !drawer || drawer.dataset.wjwInitialized === 'true') return;
    drawer.dataset.wjwInitialized = 'true';
    var panel = drawer.querySelector('.wjw-notices-panel');
    var badge = trigger.querySelector('.wjw-notices-count');
    var items = Array.prototype.slice.call(drawer.querySelectorAll('[data-wjw-notice-id]'));
    var noticeIds = items.map(function (el) { return el.getAttribute('data-wjw-notice-id'); });
    var key = 'wjw_store_updates_seen_v1';
    var lastFocus = null;
    var sessionSeen = [];
    function seenIds() {
      try { var value = JSON.parse(localStorage.getItem(key)); return Array.isArray(value) ? value : []; }
      catch (error) { return sessionSeen; }
    }
    function updateBadge() {
      if (!badge) return;
      var seen = seenIds();
      var count = noticeIds.filter(function (id) { return seen.indexOf(id) === -1; }).length;
      badge.hidden = !count;
      badge.textContent = count > 9 ? '9+' : String(count);
      trigger.setAttribute('aria-label', count ? ('Store updates, ' + count + ' unread') : 'Store updates');
    }
    function markSeen() {
      sessionSeen = noticeIds.slice();
      try { localStorage.setItem(key, JSON.stringify(noticeIds)); }
      catch (error) { /* Private browsing may block storage */ }
      updateBadge();
    }
    function open() {
      // Do not stack the navigation drawer over the updates drawer.
      var menu = document.getElementById('mobile-app-menu-drawer');
      if (menu && menu.classList.contains('is-open')) {
        var menuClose = menu.querySelector('.mobile-app-menu-close');
        if (menuClose) menuClose.click();
      }
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('wjw-notices-open');
      markSeen();
      var close = drawer.querySelector('.wjw-notices-close');
      if (close) close.focus();
    }
    function close() {
      if (!drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('wjw-notices-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    trigger.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) close(); else open();
    });
    drawer.querySelectorAll('[data-wjw-notice-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (event) {
      if (!drawer.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      var focusables = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled])'));
      if (!focusables.length) { event.preventDefault(); panel.focus(); return; }
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    // Make sure the modal cannot linger over the desktop site after resize.
    window.addEventListener('resize', function () { if (window.innerWidth >= 750) close(); });
    updateBadge();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
